import React from "react";

import HomeUI from "../../../ui/homeUI/_index";

const SumTaskListAllReport = () => {
  return (
    <>
      <HomeUI />
    </>
  )
}

export default SumTaskListAllReport
